import { render, staticRenderFns } from "./PurchaseAndSale.vue?vue&type=template&id=61b4b50c&scoped=true&"
import script from "./PurchaseAndSale.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4b50c",
  null
  
)

export default component.exports